(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('Confirmation', Confirmation);

    Confirmation.$inject = ['$resource'];

    function Confirmation ($resource) {
        var service = $resource('api/confirmation/:uuid', {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();
